export default __webpack_public_path__ + "locales/lo-LA/Article.json?hash=9e7748b99f02221af7d8357cf7ef82cd";